import { Injectable } from '@angular/core';
import { MapsBaseService } from '@shared/services/maps-base.service';

@Injectable({
    providedIn: 'root'
})
export class OpenStreetMapService extends MapsBaseService {
}
